import moment from "moment";
import QRCode from "qrcode";

export const STATUS_ACTIVE = 1;
export const STATUS_INACTIVE = 2;
export const MAX_POINT = 1000000;
export const MAX_NAME_LENGTH = 256;
export const PICKER_FORMAT = "YYYY-MM-DD HH:mm:ss";

/**
 * ข้อความ JSON ที่ฝังใน QR: {"code":"..."} (code unique ทั้งระบบ)
 * หน้าสแกนใน LIFF แกะ JSON แล้วส่ง code ไปที่ liff-backend ให้เช็คชื่อ/แต้ม/ช่วงเวลาจากฐานข้อมูล
 */
export function buildQrPayload(qrCode) {
  if (!qrCode) {
    return "";
  }
  return JSON.stringify({ code: qrCode });
}

/** สร้างรูป QR ในเบราว์เซอร์ ไม่ส่ง code (ซึ่งเป็นความลับ) ไปบริการภายนอก */
export function toQrDataUrl(text, width = 600) {
  return QRCode.toDataURL(text, {
    width,
    margin: 2,
    errorCorrectionLevel: "M"
  });
}

export async function downloadQrImage(text, fileName) {
  const dataUrl = await toQrDataUrl(text);
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = `${fileName}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/** ค่าจาก API (ISO) -> ค่าของ date-picker */
export function toPickerValue(value) {
  return value ? moment(value).format(PICKER_FORMAT) : "";
}

/** ค่าของ date-picker -> ISO พร้อม offset ให้ backend แปลงเวลาได้ไม่กำกวม */
export function toApiDate(value) {
  return value ? moment(value, PICKER_FORMAT).format() : null;
}

export function formatDateTime(value) {
  return value ? moment(value).format("DD/MM/YYYY HH:mm") : "-";
}

/** ใช้กับ vuelidate: วันสิ้นสุดต้องหลังวันเริ่ม (ว่างได้ทั้งคู่) */
export function endAfterStart(value, vm) {
  if (!value || !vm.start_at) {
    return true;
  }
  return moment(value, PICKER_FORMAT).isAfter(
    moment(vm.start_at, PICKER_FORMAT)
  );
}

export function manageRoute(route, campaignId, qrId) {
  const companyId = route.params.companyId;
  const base = companyId
    ? `/company-management/${companyId}/campaign/form/campaign_receipt/${campaignId}`
    : `/campaign/form/campaign_receipt/${campaignId}`;
  return qrId ? `${base}/qr-redeem/manage/${qrId}` : base;
}
